module.exports = __webpack_public_path__ + "assets/skill-writing.a8a7bdd0.svg";